import React from "react";
import Typography from "./Typography/Typography";

export default function BlackCard({ data, height, background, color, image }) {
   if (image) {
      return (
         <div
            style={{
               backgroundImage: `url(${image})`,
               minHeight: height || "344px",
               backgroundSize: "cover",
               backgroundPosition: "center center",
               backgroundRepeat: "no-repeat",
               width: "100%",
            }}>
            <div
               style={{
                  background: `rgba(14, 14, 14, 0.65)`,
                  minHeight: "inherit",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
               }}>
               <div style={{ padding: "31px" }}>
                  <Typography element="span" className="fs24 font22 mb10 text-white" syne fontWeight={600}>
                     {data.title.split("\n").map((text, idx) => (
                        <div key={`title-text-${idx}`}>{text}</div>
                     ))}
                  </Typography>
                  <div className="my-3" style={{ background: "#FF5101", padding: "2px", width: "20px" }}></div>
                  <p className="mt10 font-17 font-DMSans font-400 text-white">{data.description}</p>
               </div>
            </div>
         </div>
      );
   }
   return (
      <>
         <div
            style={{
               minHeight: height || "auto",
               background: background || "black",
               color: color || "white",
            }}
            id="card-ui">
            <div style={{ padding: "31px" }}>
               <Typography element="span" className="fs24 font22 mb10" syne fontWeight={600}>
                  {data.title.split("\n").map((text, idx) => (
                     <div key={`title-text-${idx}`}>{text}</div>
                  ))}
               </Typography>
               <div className="my-3" style={{ background: "#FF5101", padding: "2px", width: "20px" }}></div>
               <p className="mt10 font-17 font-DMSans font-400" style={{ textAlign: "justify" }}>
                  {data.description}
               </p>
            </div>
         </div>
      </>
   );
}
